import { Button, CellContentPosition, ConfirmationDialog, Icon, IconButton, Stack, TableCell, TableRow } from "@tm/components"
import { CompilationModel, useDeleteCompilations } from "@tm/data/compilations"
import { formatDate } from "@tm/utils"
import { useLocalization } from "@tm/localization"
import { useState } from "react"
import { ConfirmationDialogKeys } from "@tm/models"
import { isWM } from "../../../../../utils"
import { useFavoriteArticlesStore } from "../../store"

type Props = {
    compilation: CompilationModel
    onOpenCompilationDetails(id: string): void
}

export function CompilationsListItem({ compilation, onOpenCompilationDetails }: Props) {
    const { translateText } = useLocalization()
    const { setCompilationToEdit } = useFavoriteArticlesStore()
    const { deleteCompilations } = useDeleteCompilations(isWM())
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false)

    function handleClickDetails() {
        onOpenCompilationDetails(compilation.id)
    }

    function handleClickEdit(e: React.MouseEvent<HTMLButtonElement>) {
        e.stopPropagation()
        setCompilationToEdit({
            ...compilation,
            compilationId: compilation.id,
            type: "edit",
        })
    }

    function handleClickDelete(e: React.MouseEvent<HTMLButtonElement>) {
        e.stopPropagation()
        setShowDeleteDialog(true)
    }

    function renderDate(dateString: Date | undefined) {
        if (!dateString) {
            return
        }

        return formatDate(new Date(dateString), "d")
    }

    return (
        <TableRow key={compilation.id} colCount={isWM() ? 6 : 5} onClick={handleClickDetails} sx={{ cursor: "pointer" }}>
            <TableCell>{compilation.name}</TableCell>
            <TableCell>{compilation.description}</TableCell>
            {isWM() && <TableCell>{translateText(compilation.isPublic ? 1254 : 1253)}</TableCell>}
            <TableCell>{renderDate(compilation.createDate)}</TableCell>
            <TableCell>{renderDate(compilation.updateDate)}</TableCell>
            <TableCell alignContent={CellContentPosition.right}>
                <Stack direction="row" gap={1}>
                    <IconButton onClick={handleClickEdit} title={translateText(122)} disabled={!compilation.isOwn}>
                        <Icon name="edit_change" />
                    </IconButton>
                    <IconButton onClick={handleClickDelete} title={translateText(624)} disabled={!compilation.isOwn}>
                        <Icon name={!showDeleteDialog ? "delete" : undefined} />
                    </IconButton>
                    <Button onClick={handleClickDetails} endIcon={<Icon name="details" />} variant="contained">
                        {translateText(43)}
                    </Button>
                    {showDeleteDialog && (
                        <ConfirmationDialog
                            open
                            confirmationButtonText={translateText(585)}
                            cancelButtonText={translateText(584)}
                            onConfirm={() => deleteCompilations([compilation.id])}
                            onCancel={() => setShowDeleteDialog(false)}
                            confirmationKey={ConfirmationDialogKeys.DeleteCompilations}
                        >
                            {translateText(1313)}
                        </ConfirmationDialog>
                    )}
                </Stack>
            </TableCell>
        </TableRow>
    )
}
